
export class SearchForm {
    private readonly form: HTMLFormElement | null;
    private readonly trovitTypeDropdown: HTMLElement | null | undefined;
    private readonly inputText: HTMLInputElement | null | undefined;

    constructor() {
        this.form = document.querySelector('#home-search-form-id');
        this.trovitTypeDropdown = this.form?.querySelector('.js-search-form-type');
        this.inputText = this.form?.querySelector('.js-search-form-text');
    }

    init() {
        this.registerEvents();
    }

    private registerEvents() {
        this.registerTrovitTypeClickEvent();
    }

    private registerTrovitTypeClickEvent() {
        this.trovitTypeDropdown?.addEventListener("wl-submit", this.submitForm)
    }

    private submitForm = (e: Event) => {
        if (this.inputText && this.inputText.value.trim() !== '') {
            this.form?.submit();
        }
    }
}

window.addEventListener("load", () => {
    new SearchForm().init();
});